<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Maintenance Record</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">
  <mat-tab-group>
    <mat-tab label="Details">
      <div class="container-fluid p-3">

        <p><b>Title</b>: {{ asset_maintenance_record.title }}</p>
        <p><b>Type</b>: {{ assetMaintenanceRecordsService.getTypeLabel(asset_maintenance_record.type) }} <span *ngIf="asset_maintenance_record.type_other">- {{ asset_maintenance_record.type_other }}</span></p>
        <p><b>Status</b>: <span [style.color]="assetMaintenanceRecordsService.getStatusColor(asset_maintenance_record.status) || null">{{ assetMaintenanceRecordsService.getStatusLabel(asset_maintenance_record.status) }}</span></p>
        <p><b>Priority</b>: <span [style.color]="assetMaintenanceRecordsService.getPriorityColor(asset_maintenance_record.priority) || null">{{ assetMaintenanceRecordsService.getPriorityLabel(asset_maintenance_record.priority) }}</span></p>

        <ng-container *ngIf="asset_maintenance_record.description">
          <p><b>Description</b>: <br><span class="multiline-text">{{ asset_maintenance_record.description }}</span></p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.due_at">
          <p>
            <b>Due Date:</b> <span [style.color]="utils.getDueDateColor(asset_maintenance_record.due_at) || null">
              {{ (asset_maintenance_record.due_at * 1000) | timezoneConvertLong }}
            </span>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.trigger_type">
          <p><b>Created From</b>: {{ assetMaintenanceRecordsService.getTriggerTypeLabel(asset_maintenance_record.trigger_type) }}</p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.started_at">
          <p>
            <b>Started At</b>: {{ (asset_maintenance_record.started_at * 1000) | timezoneConvertLong }}<br>
            <b>Started By</b>: <a *ngIf="asset_maintenance_record.started_by_user" (click)="onUserPublicView(asset_maintenance_record.started_by_user.hash)" matTooltip="View User Public Profile">{{ asset_maintenance_record.started_by_user.contact_person }}</a>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.completed_at">
          <p>
            <b>Completed At</b>: {{ (asset_maintenance_record.completed_at * 1000) | timezoneConvertLong }}<br>
            <b>Completed By</b>: <a *ngIf="asset_maintenance_record.completed_by_user" (click)="onUserPublicView(asset_maintenance_record.completed_by_user.hash)" matTooltip="View User Public Profile">{{ asset_maintenance_record.completed_by_user.contact_person }}</a>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.cancelled_at">
          <p>
            <b>Cancelled At</b>: {{ (asset_maintenance_record.cancelled_at * 1000) | timezoneConvertLong }}<br>
            <b>Cancelled By</b>: <a *ngIf="asset_maintenance_record.cancelled_by_user" (click)="onUserPublicView(asset_maintenance_record.cancelled_by_user.hash)" matTooltip="View User Public Profile">{{ asset_maintenance_record.cancelled_by_user.contact_person }}</a>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.status === 'completed'">

          <ng-container *ngIf="asset_maintenance_record.time_spent_value">
            <p><b>Time Spent</b>: {{ asset_maintenance_record.time_spent_value }} {{ assetMaintenanceRecordsService.getTimeSpentUnitLabel(asset_maintenance_record.time_spent_unit) }}</p>
          </ng-container>

          <ng-container *ngIf="asset_maintenance_record.total_cost">
            <p><b>Total Cost</b>: {{ assetsService.getCostAmountDisplay(asset_maintenance_record.total_cost, app.account.currency_code) || '' }}</p>
          </ng-container>

          <ng-container *ngIf="asset_maintenance_record.completion_summary">
            <p><b>Completion Summary</b>: <br><span class="multiline-text">{{ asset_maintenance_record.completion_summary }}</span></p>
          </ng-container>

        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.status === 'cancelled' && asset_maintenance_record.cancellation_details">
          <p><b>Cancellation Details</b>: <br><span class="multiline-text">{{ asset_maintenance_record.cancellation_details }}</span></p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.notes">
          <p><b>Notes</b>: <br><span class="multiline-text">{{ asset_maintenance_record.notes }}</span></p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record?.maintenance_schedule">
          <p><b>Maintenance Schedule</b>: <a (click)="onViewSchedule(asset_maintenance_record.maintenance_schedule.id)" matTooltip="View Maintenance Schedule">{{ asset_maintenance_record.maintenance_schedule.title }}</a></p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record?.contractor">
          <p>
            <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Name</b>: {{ asset_maintenance_record.contractor.name }}<br>
            <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Industry</b>: {{ asset_maintenance_record.contractor.industry }}<br>
            <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Main Contact</b>: <span *ngIf="asset_maintenance_record.contractor?.main_contact"><a (click)="onUserPublicView(asset_maintenance_record.contractor.main_contact.hash)" matTooltip="View User Public Profile">
              {{ asset_maintenance_record.contractor.main_contact.contact_person }}
            </a></span>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record?.vendor">
          <p>
            <b>Vendor Name</b>: {{ asset_maintenance_record?.vendor?.name }}<br>
            <b>Vendor Email</b>: <a *ngIf="asset_maintenance_record?.vendor?.email" [href]="'mailto:' + asset_maintenance_record?.vendor?.email" target="_blank">{{ asset_maintenance_record?.vendor?.email }}</a><br>
            <b>Vendor Phone Number</b>: <a *ngIf="asset_maintenance_record?.vendor?.phone_e164" [href]="'tel:' + asset_maintenance_record?.vendor?.phone_e164" target="_blank">{{ asset_maintenance_record?.vendor?.phone }}</a>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record?.users && asset_maintenance_record.users.length">
          <p class="mb-1"><b>Assignees</b>:</p>
          <ul>
            <li *ngFor="let user of asset_maintenance_record.users">
              <a (click)="onUserPublicView(user.hash)" matTooltip="View User Public Profile">
                {{ user.contact_person }}
              </a>
            </li>
          </ul>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.date_created">
          <p>
            <b>Created At</b>: {{ (asset_maintenance_record.date_created * 1000) | timezoneConvertLong }}<br>
            <b>Created By</b>:
            <span *ngIf="asset_maintenance_record?.created_by_user; else createdBySystem"><a (click)="onUserPublicView(asset_maintenance_record.created_by_user.hash)" matTooltip="View User Public Profile">
              {{ asset_maintenance_record.created_by_user.contact_person }}
            </a></span>
            <ng-template #createdBySystem>
              System
            </ng-template>
          </p>
        </ng-container>

        <ng-container *ngIf="asset_maintenance_record.date_modified">
          <p>
            <b>Last Updated At</b>: {{ (asset_maintenance_record.date_modified * 1000) | timezoneConvertLong }}<br>
            <b>Last Updated By</b>:
            <span *ngIf="asset_maintenance_record?.updated_by_user; else updatedBySystem"><a (click)="onUserPublicView(asset_maintenance_record.updated_by_user.hash)" matTooltip="View User Public Profile">
              {{ asset_maintenance_record.updated_by_user.contact_person }}
            </a></span>
            <ng-template #updatedBySystem>
              System
            </ng-template>
          </p>
        </ng-container>

      </div>
    </mat-tab>

    <mat-tab label="Files" *ngIf="asset_maintenance_record?.files?.length">
      <div class="mx-3">
        <app-files-list [files]="asset_maintenance_record.files"></app-files-list>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
